import { mergeAttributes, Node } from "@tiptap/core";
import config from "config";
import StepperItem from "./StepperItem";

const LABELS = {
  PT_BR: {
    approved: "Aprovado",
    rejected: "Rejeitado",
    where_is: "Onde está",
    next_steps: "Próximos passos",
  },
  EN: {
    approved: "Approved",
    rejected: "Rejected",
    where_is: "Where is it?",
    next_steps: "Next steps",
  },
};

export const StepperList = Node.create({
  name: "stepperList",

  group: "block",

  content: "stepperItem+",

  isolating: true,

  addOptions() {
    return {
      language: "PT_BR", // default
    };
  },

  addExtensions() {
    return [StepperItem];
  },

  parseHTML() {
    return [
      {
        tag: `td[data-type="${this.name}"]`,
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    const { language } = this.options;
    const labels = LABELS[language as keyof typeof LABELS];

    return [
      "td",
      mergeAttributes(HTMLAttributes, {
        "data-type": this.name,
        width: "50%",
        class: "stepper-list",
      }),
      ["table", {}, 0],
      [
        "table",
        {
          class: "stepper-legend",
        },
        [
          "tr",
          {},
          [
            "td",
            { class: "stepper-legend__icon" },
            [
              "img",
              {
                src: `${config.api}/assets/status/completed.png`,
                width: "16px",
              },
            ],
          ],
          ["td", { class: "stepper-legend__text" }, labels.approved],
          [
            "td",
            { class: "stepper-legend__icon" },
            [
              "img",
              {
                src: `${config.api}/assets/status/canceled.png`,
                width: "16px",
              },
            ],
          ],
          ["td", { class: "stepper-legend__text" }, labels.rejected],
          [
            "td",
            { class: "stepper-legend__icon" },
            [
              "img",
              {
                src: `${config.api}/assets/status/working.png`,
                width: "16px",
              },
            ],
          ],
          ["td", { class: "stepper-legend__text" }, labels.where_is],
          [
            "td",
            { class: "stepper-legend__icon" },
            [
              "img",
              {
                src: `${config.api}/assets/status/pending.png`,
                width: "16px",
              },
            ],
          ],
          ["td", { class: "stepper-legend__text" }, labels.next_steps],
        ],
      ],
    ];
  },

  addCommands() {
    return {
      // ...outros comandos...
      updateStepperItemPositions:
        () =>
        ({ tr, state, dispatch }) => {
          const stepperItems = [];
          state.doc.descendants((node, pos) => {
            if (node.type.name === "stepperItem") {
              stepperItems.push({ node, pos });
            }
          });

          stepperItems.forEach((item, idx) => {
            const attrs = {
              ...item.node.attrs,
              first: idx === 0,
              last: idx === stepperItems.length - 1,
            };
            tr.setNodeMarkup(item.pos, undefined, attrs);
          });
          if (stepperItems.length && dispatch) {
            dispatch(tr);
            return true;
          }
          return false;
        },
    };
  },

  // addNodeView() {
  //   return ReactNodeViewRenderer(StepperView)
  // },
});

export default StepperList;
